import { toast } from "sonner";

// Summarizes the array of action results returned by `/api/chat` and fires
// nicely-grouped sonner toasts: e.g. "Mochi added 2 tasks + 1 reminder ✨".
//
// Returns an action counts object so callers can branch on specific types
// (e.g. ask for notification permission only when a reminder was added).
export function summarizeAndToastChatActions(actions) {
    const counts = (actions || []).reduce((acc, a) => {
        acc[a.type] = (acc[a.type] || 0) + 1;
        return acc;
    }, {});

    const pluralize = (n, word) => `${n} ${word}${n > 1 ? "s" : ""}`;

    const addParts = [];
    if (counts.add_task) addParts.push(pluralize(counts.add_task, "task"));
    if (counts.add_habit) addParts.push(pluralize(counts.add_habit, "habit"));
    if (counts.add_reminder) addParts.push(pluralize(counts.add_reminder, "reminder"));
    if (counts.add_list_item) addParts.push(pluralize(counts.add_list_item, "list item"));

    const removeParts = [];
    if (counts.remove_task) removeParts.push(pluralize(counts.remove_task, "task"));
    if (counts.remove_habit) removeParts.push(pluralize(counts.remove_habit, "habit"));
    if (counts.remove_reminder) removeParts.push(pluralize(counts.remove_reminder, "reminder"));
    if (counts.remove_list_item) removeParts.push(pluralize(counts.remove_list_item, "list item"));

    const editParts = [];
    if (counts.edit_task) editParts.push(pluralize(counts.edit_task, "task"));
    if (counts.edit_habit) editParts.push(pluralize(counts.edit_habit, "habit"));
    if (counts.edit_reminder) editParts.push(pluralize(counts.edit_reminder, "reminder"));
    if (counts.edit_list_item) editParts.push(pluralize(counts.edit_list_item, "list item"));

    const doneParts = [];
    if (counts.complete_task) doneParts.push(pluralize(counts.complete_task, "task"));
    if (counts.complete_habit) doneParts.push(pluralize(counts.complete_habit, "habit"));
    if (counts.complete_reminder) doneParts.push(pluralize(counts.complete_reminder, "reminder"));
    if (counts.complete_list_item) doneParts.push(pluralize(counts.complete_list_item, "list item"));

    if (addParts.length) toast.success(`Mochi added ${addParts.join(" + ")} ✨`);
    if (doneParts.length) toast.success(`Mochi marked ${doneParts.join(" + ")} complete ✓`);
    if (editParts.length) toast(`Mochi updated ${editParts.join(" + ")} ✎`, { icon: "✏️" });
    if (removeParts.length) toast(`Mochi removed ${removeParts.join(" + ")} ✕`, { icon: "🗑️" });

    return counts;
}
